exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address-form[data-v-4ddcb484]{margin-top:15px}", ""]);

// exports
